<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/registrolog`;

const registroLogService = {
  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching registro log: ' + error.message);
    }
  },

  async getEstadoProcesos() {
    try {
      const response = await axios.get(`${apiUrl}/estado-procesos`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching estado de procesos: ' + error.message);
    }
  },

  // Chequeo de salud de los procesos CORE del servidor. Devuelve
  // { ok, estado: 'OK' | 'ERROR', procesos: [...] }.
  async getHealthProcesosCore() {
    try {
      const response = await axios.get(`${apiUrl}/health-procesos-core`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching health de procesos core: ' + error.message);
    }
  },

  async getByProceso(idProceso) {
    try {
      const response = await axios.get(`${apiUrl}/proceso/${idProceso}`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching detalle de proceso: ' + error.message);
    }
  },

  async eliminarTodo() {
    try {
      const response = await axios.delete(apiUrl, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error eliminando registros de log: ' + error.message);
    }
  },
};

export default registroLogService;
</script>
